import type React from "react"
import { memo, useCallback } from "react"
import { ReactComponent as LinkIcon } from "@assets/icons/link_icon.svg"
import { useClipboard } from "@mantine/hooks"
import { twMerge } from "tailwind-merge"

type CopyLinkProps = {
  copy: string
  label: string
  withButton?: boolean
  btnLabel?: string
  eventBtn?(): void
  btnVariant?: "primary" | "secondary"
}

const CopyLink: React.FC<CopyLinkProps> = ({
  label,
  copy,
  withButton,
  btnLabel,
  eventBtn,
  btnVariant = "secondary",
}) => {
  const clipboard = useClipboard()

  const handleEventBtn = useCallback(() => {
    if (!eventBtn) {
      return clipboard.copy(copy)
    }

    return eventBtn()
  }, [eventBtn, clipboard, copy])

  const handleEventInput = useCallback(() => {
    if (withButton) {
      if (eventBtn) {
        return clipboard.copy(copy)
      }
    } else {
      return clipboard.copy(copy)
    }
  }, [withButton, eventBtn, clipboard, copy])

  const variantBtnClasses = {
    primary: "btn-primary-lg",
    secondary: "btn-secondary-lg",
  }

  return (
    <div className="flex flex-col gap-y-4">
      <div className="flex flex-col gap-y-2">
        <span className="text-pn-callout-emphasis text-pn_gray-2">{label}</span>
        <div
          onClick={handleEventInput}
          className="border cursor-pointer border-pn_gray-200 bg-pn_white rounded-lg flex items-center gap-x-2 p-4"
        >
          <LinkIcon className="w-6 h-6 [&>path]:stroke-black" />
          <span className="text-pn-body-regular text-pn_gray-950">{copy}</span>
        </div>
      </div>
      {withButton && (
        <button onClick={handleEventBtn} className={twMerge(variantBtnClasses[btnVariant])}>
          {btnLabel}
        </button>
      )}
    </div>
  )
}
export default memo(CopyLink)
